import { PropertySettingsOwnersTabFormValues } from 'pages/property/owners/PropertySettingsOwnersTab.schema';
import { useParams } from 'react-router-dom';
import useOwnerNotesBulkMutation from './useOwnerNotesBulkMutation';

const useCommunicationSettingsFormSubmit = () => {
  const { uid: propertyUid } = useParams();
  const { updateOwnerNotes } = useOwnerNotesBulkMutation();

  const updateCommunicationSettings = async (
    payload: PropertySettingsOwnersTabFormValues,
  ) => {
    return updateOwnerNotes({
      updateContext: {
        applyToAll: false,
        propertyUids: [propertyUid as string],
      },
      ownerNotes: {
        notes: payload.communicationSettings?.notes_htmlContent ?? '',
      },
      collectAndRemitTaxes:
        payload.communicationSettings?.collectAndRemitTaxes === 'YES',
      copyOwnerWhenBookingConfirmed:
        payload.communicationSettings?.copyOwnerWhenBookingConfirmed === 'YES',
    });
  };

  return { updateCommunicationSettings };
};

export default useCommunicationSettingsFormSubmit;
